import { Route } from '../router';
import { CORE_ROUTES } from './core';
import { CLIENTS_ROUTES } from './clients';
import { PEOPLE_ROUTES } from './people';
import { FINANCE_ROUTES } from './finance';
import { ADMIN_ROUTES } from './admin';
import { REPORTS_ROUTES } from './reports';

/** First match wins. Domain files own their own paths; core holds the cross-cutting ones. */
export const ROUTES: Route[] = [...CORE_ROUTES, ...CLIENTS_ROUTES, ...PEOPLE_ROUTES, ...FINANCE_ROUTES, ...ADMIN_ROUTES, ...REPORTS_ROUTES];
